import getChannelBridgeApi from '@/libs/functions/appAdapter'
import { getUrlAllParams } from '@/libs/functions/getValue'
import { getStorage } from '@/libs/functions/onStorage'
import { useEffect } from 'react'

export default function MiniProgramPay() {
  const params = getUrlAllParams()
  const channel = getStorage('channel')
  const channelApi = getChannelBridgeApi(channel)

  useEffect(() => {
    if (
      channelApi &&
      channelApi.goToPayWithParams &&
      typeof params === 'object'
    ) {
      channelApi.goToPayWithParams(params)
    }
  }, [])

  return (
    <div>
      <h3
        style={{
          marginTop: 300,
          textAlign: 'center',
        }}
      >
        正在加载支付环境...
      </h3>
    </div>
  )
}
